import Axios from 'axios'
import moment from 'moment'

export default {
    namespaced: true,
    state: {
        volatilities: [],
    },
    getters: {
        volatilities: (state) => {
            return state.volatilities;
        },
        volatilitiesOptions: (state) => {
            return state.volatilities.map(ccy => ({id: ccy.id, name: ccy.name})) ?? [];
        },
    },
    mutations: {
        setVolatilities(state, {volatilities}) {
            state.volatilities = volatilities;
        },
    },
    actions: {
        async refreshVolatilities({commit}) {
            const response = await Axios.get("currency/api/v1/volatility?size=10000")
            commit("setVolatilities", {volatilities: response.data})
        },

    }
}